<template>
  <!--Extras Case-4-->
  <div
    id="modalCase4"
    class="modal s-modal s-modal--warning"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div><i class="icon-warning"></i></div>
            <div>{{ dictionary.modalCase4Title }}</div>
          </div>
        </div>
        <div class="modal-body">
          <div><p v-html="text"></p></div>

          <ul class="b-extras-as-badges-list">
            <li>
              <div class="e-extra-as-badge">{{ masterTitle }}</div>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <ul>
            <li>
              <button
                type="button"
                class="btn btn-outline-danger btn-full-width"
                @click="onClickUndo">
                {{ dictionary.modalCase4ButtonUndoText }}
              </button>
            </li>
            <li>
              <button
                type="button"
                class="btn btn-primary btn-full-width"
                @click="onClickSubmit">
                {{ dictionary.modalCase4ButtonSubmitText }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from './../../lib/lib'

export default {
  props: {
    master: {
      required: false,
      type: String,
      default: '',
    },
    child: {
      required: false,
      type: String,
      default: '',
    },
  },
  emits: ['submit', 'undo'],
  data() {
    return { records: [] }
  },
  computed: {
    text() {
      const value = `<strong>${this.childTitle}</strong>`
      return this.dictionary.modalCase4Text.replace('{0}', value)
    },

    masterTitle() {
      return this.master
        ? this.records.find((i) => i.code === this.master).description
        : ''
    },
    childTitle() {
      return this.child
        ? this.records.find((i) => i.code === this.child).description
        : ''
    },
  },
  mounted() {
    const { amenitiesDefinitions } = lib.getData('bookingData')
    this.records = amenitiesDefinitions
  },
  methods: {
    onClickUndo() {
      this.$emit('undo')
    },

    onClickSubmit() {
      this.$emit('submit', this.master, this.child)
    },
  },
}
</script>
